import _ from "lodash";
import React, { useCallback, useState } from "react";

import { connect } from "react-redux";
import classNames from "classnames";

import { Modal, Button, Tooltip } from "@toddle-edu/ds-web";

import {
  addMembersInChannel,
  addMembersInDepartmentChannel,
} from "MessagingV2/modules/MessagingModule";
import { useI18n } from "Hooks";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";
import classes from "./SimpleAddMemberModal.scss";
import MemberListWithQueryWrapper from "./SimpleDepartmentFamilyMemberQueryWrapper";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const styles = {
  addMemberModalBodyStyles: {
    padding: "0px",
    overflow: "hidden",
  },
  modalBodyStyles: {
    paddingTop: "4px",
    paddingRight: "0px",
    overflow: "hidden",
  },
  shortcutCode: { code: "Enter", shiftKey: true },
};

const getHeaderTitle = ({ channelType, channelLabel, t }) => {
  switch (channelType) {
    case CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT:
      return t("common:add_family_member_to_label", {
        label: channelLabel,
      });
    default:
      return t("common:manage_members_for_label", { label: channelLabel });
  }
};

const SimpleAddMemberModal = props => {
  const {
    onCloseModal,
    prevUsers,
    chatId,
    addMembersInChannel,
    addMembersInDepartmentChannel,
    channelLabel,
    channelType,
    allSelected,
  } = props;

  const { t } = useI18n(["common"]);

  const [selectedAddUsers, setSelectedAddUsers] = useState([]);

  const [isUpdating, setIsUpdating] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const isDepartmentChannel = _.isEqual(
    channelType,
    CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT
  );

  const checkIfTextOverflow = useCallback(node => {
    if (node) {
      if (node.offsetHeight < node?.scrollHeight) {
        setShowTooltip(true);
      }
    }
  }, []);
  const handleAddUsers = React.useCallback(users => {
    setSelectedAddUsers(state => {
      const userList = _.map(users, user => {
        return _.pick(user, ["id", "type"]);
      });
      const allUsers = [...state, ...userList];
      return _.uniqBy(allUsers, "id");
    });
  }, []);

  const handleRemoveUsers = users => {
    const userIdsSet = new Set(_.map(users, "id"));
    setSelectedAddUsers(prevUsers => {
      return _.filter(prevUsers, user => !userIdsSet.has(user.id));
    });
  };

  const handleUpdateUsers = async () => {
    setIsUpdating(true);
    const asyncQuery = isDepartmentChannel
      ? addMembersInDepartmentChannel
      : addMembersInChannel;
    const isSuccess = await asyncQuery({
      chatId,
      users: _.concat(selectedAddUsers, prevUsers),
    });
    if (isSuccess) {
      setSelectedAddUsers([]);
    }
    setIsUpdating(false);
    onCloseModal(false);
  };

  const getIsButtonDisabled = () => {
    return _.isEmpty(selectedAddUsers) || isUpdating;
  };

  const headerTitle = getHeaderTitle({ channelType, channelLabel, t });
  return (
    <Modal
      width="480px"
      height="560px"
      isClose={false}
      onClose={onCloseModal}
      dsVersion="2.0"
    >
      <Modal.Header isClosable hasSeparator>
        <div className={classNames("heading-6", classes.manageMemberHeader)}>
          <ConditionalWrapper
            wrapper={<Tooltip tooltip={headerTitle} />}
            condition={showTooltip}
            type={"wrapperAsElement"}
          >
            <div ref={checkIfTextOverflow} className={"heading-6"}>
              {headerTitle}
            </div>
          </ConditionalWrapper>
        </div>
      </Modal.Header>
      <Modal.Body style={styles.addMemberModalBodyStyles}>
        <MemberListWithQueryWrapper
          handleAddUsers={handleAddUsers}
          handleRemoveUsers={handleRemoveUsers}
          selectedUsers={selectedAddUsers}
          prevUsers={prevUsers}
          allSelected={allSelected}
          isUpdating={isUpdating}
        />
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.modalFooterContainer}>
          <div className="text-label">
            {t("common:count_family_member_total", {
              count: _.size(selectedAddUsers),
            })}
          </div>
          <div className={classes.modalButtonContainer}>
            <Button
              size="medium"
              variant="progressive"
              onClick={handleUpdateUsers}
              disabled={getIsButtonDisabled()}
              dsVersion="2.0"
              shortcut={styles.shortcutCode}
            >
              {t("common:add_to_label", {
                label: t("common:channel"),
              })}
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreators = {
  addMembersInChannel,
  addMembersInDepartmentChannel,
  setToastMsg,
};

export default connect(null, mapActionCreators)(SimpleAddMemberModal);
